import { Autocompleter } from 'Shared/Autocompleter/Autocompleter';

// eslint-disable-next-line no-var
export var TeamFinder = (window.TeamFinder = new Class({
   Extends: Autocompleter.Request.API_2_0,

   el: null,

   initialize: function (el, options) {
      if (!App.noAvatarUrl) {
         console.error('App.noAvatarUrl is not set.');
      }
      options = Object.merge(
         {
            className: 'blurb-finder',
            fxOptions: null,
            maxChoices: 5,
            delay: 100,
            truncateText: false,
            overflow: false,
            injectChoice: this.injectChoice.bind(this),
         },
         options
      );

      this.el = el;
      this.maxChoices = options.maxChoices;

      this.parent(this.el, 'teams/search', options);
      this.url = this.request.request.options.url;

      // Prevent blur event from firing in Safari when dragging the scrollbar
      this.choices.addEvent('mousedown', function (ev) {
         ev.stop();
      });
   },

   query: function () {
      this.toggleIndicator(true);

      let data = Object.clone(this.options.getData) || {};
      let endpoint = this.url + '/' + this.queryValue;
      let queryParams = '?limit=' + this.maxChoices;

      this.request.request.options.url = endpoint + queryParams;

      this.fireEvent('onRequest', [this.element, this.request, data, this.queryValue]);
      this.request.send({ data: data });
   },

   injectChoice: function (team) {
      if (!this.el.isDisplayed()) {
         return;
      }

      let data = {
         team: team,
         imageUrl: team.imageUrl || App.noAvatarUrl,
         showImage: true,
      };

      let template = window.hbsTemplates('TEAM_HBS');

      let choice = template(data);

      choice.store('team', team);
      choice.inputValue = '';

      this.addChoiceEvents(choice).inject(this.choices);
   },
}));
